import React from 'react';
import styled from '@emotion/styled';
import TableNoResults from '@/components/_common/Table/TableNoResults';

const NoResults = () => {
  return (
    <NoResultContainer>
      <TableNoResults />
    </NoResultContainer>
  );
};

export default NoResults;

const NoResultContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4)};
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-bottom-left-radius: ${({ theme }) => `${theme.shape.borderRadius * 2.4}px`};
  border-bottom-right-radius: ${({ theme }) => `${theme.shape.borderRadius * 2.4}px`};
`;
